import { startOfWeek, addDays, format, formatISO, minutesToHours, isThisWeek, } from 'date-fns';
import isBefore from 'date-fns/isBefore';
import endOfWeek from 'date-fns/endOfWeek';
import getMonth from 'date-fns/getMonth';
export var minsToHours = function (value) {
    var hours = minutesToHours(value);
    var minutes = value - hours * 60;
    return { hours: hours, minutes: minutes };
};
export var createTimeText = function (timeSpent) {
    var _a = minsToHours(timeSpent), minutes = _a.minutes, hours = _a.hours;
    var hoursText = hours ? hours + " h " : '';
    var minsText = '';
    if (minutes)
        minsText = minutes + " min";
    else
        minsText = hours ? '' : '< 1 min';
    var summary = "" + hoursText + minsText;
    return summary;
};
export var getStartDate = function (date) {
    return startOfWeek(date, { weekStartsOn: 1 });
};
export var getISOWeekDays = function (date) {
    var start = getStartDate(date);
    return new Array(7).fill(null).map(function (_, idx) {
        var day = addDays(start, idx);
        var ISOday = formatISO(day).substring(0, 10);
        var abbr = format(day, 'ccccc');
        return { day: ISOday, abbr: abbr };
    });
};
export var checkIfWeekIsInThePast = function (date, currentDate) {
    var startOfTheCurrentWeek = getStartDate(currentDate);
    return isBefore(date, startOfTheCurrentWeek);
};
export var checkIfWeekIsCurrent = function (date) {
    return isThisWeek(date, { weekStartsOn: 1 });
};
export var getWeekRange = function (startDate) {
    return [getStartDate(startDate), endOfWeek(startDate, { weekStartsOn: 1 })];
};
export var formatWeekRange = function (startDate, endDate) {
    return getMonth(startDate) === getMonth(endDate)
        ? format(startDate, 'MMMM') + " " + format(startDate, 'd') + " \u2013 " + format(endDate, 'd')
        : format(startDate, 'MMMM d') + " \u2013 " + format(endDate, 'MMMM d');
};
export var getWeeklyCalendarData = function (startDate, currentDate) {
    var weekRange = getWeekRange(startDate);
    var start = weekRange[0];
    var isWeekInThePast = checkIfWeekIsInThePast(start, currentDate);
    var isCurrentWeek = checkIfWeekIsCurrent(startDate);
    var days = getISOWeekDays(startDate);
    return {
        days: days,
        isWeekInThePast: isWeekInThePast,
        weekRange: weekRange,
        isCurrentWeek: isCurrentWeek,
        startDate: startDate,
        currentDate: currentDate,
    };
};
